// @ts-nocheck
import * as React from "react";

const CheckmarkSquare2Fill: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M18 3H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3zm-1.7 6.61l-4.57 6a1 1 0 01-1.58.01l-2.44-3.11a1.001 1.001 0 011.58-1.23l1.63 2.08 3.78-5a1.006 1.006 0 111.6 1.22v.03z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(CheckmarkSquare2Fill);
